module.exports = __webpack_public_path__ + "media/boschautoparts/logo-2-fddf6100.png";